import React, { useEffect, useState } from 'react';
import EirPrepayDeviceDetails from './EirPrepayDeviceDetails';
import { Link, Typography } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useApolloClient } from '@apollo/client';
import ENDPOINT from '../graphql/GraphQLConstants';
import Loading from '../shared/Loading';
import Routing from '../../utils/Routing';
import CloseIcon from '@material-ui/icons/Close';
import {
    Grid,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Button,
} from '@material-ui/core';
export default function EirPrepayDeviceDetailsContainer(props) {
    const [deviceDetails, setDeviceDetails] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const graphql = useApolloClient();
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [APIStatus, setAPIStatus] = useState('');
    const handleClose = () => {
        setDialogOpen(false);
    };
    const setDialogOpenResponse = response => {
        setDialogOpen(response);
    };
    const setAPIErrorResponse = response => {
        setAPIStatus(response);
    };
    useEffect(() => {
        setIsLoading(true);
        loadData();
    }, []);
    const loadData = async () => {
        try {
            const deviceName = Routing.getQueryParameter('name');
            const res = await graphql.query({
                query: ENDPOINT.GET_DEVICE_DETAILS_BYNAME,
                variables: { deviceName: deviceName },
            });
            if (res.data.deviceDetailsByName) {
                setDeviceDetails(res.data.deviceDetailsByName);
                setIsLoading(false);
            }
        } catch (err) {
            console.log(err.message);
        }
    };
    return (
        <div className='device-content-holder'>
            {APIStatus && (
                <Dialog
                    PaperProps={{ className: 'prepaydialogPaper' }}
                    open={dialogOpen}
                    onClose={handleClose}
                    aria-labelledby='alert-dialog-title'
                    aria-describedby='alert-dialog-description'
                    className='prepayeirDialogContainer'>
                    <DialogTitle id='alert-dialog-title' className='dialogTitle'></DialogTitle>
                    <IconButton
                        aria-label='close'
                        className='prepaycloseButton'
                        onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                    <DialogContent className='prepayeirDialogContent'>
                        <DialogContentText
                            id='alert-dialog-description'
                            className='prepaynotification'>
                            {APIStatus}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            align='center'
                            className='prepayeirDialog'>
                            <Button className='prepaycancelBtn' onClick={handleClose}>
                                Close
                            </Button>
                        </Grid>
                    </DialogActions>
                </Dialog>
            )}
            {isLoading ? (
                <Loading className='m-5' />
            ) : (
                <div>
                    <div class='header-gap'>
                        <Link href='/mobile/phones/prepay/'>
                            <ArrowBackIosIcon className='arrow-back'></ArrowBackIosIcon>
                            <Typography className='back-text'>VIEW ALL PHONES</Typography>
                        </Link>
                    </div>
                    <div className='component-position'>
                        <EirPrepayDeviceDetails
                            device={deviceDetails}
                            getAPIError={setAPIErrorResponse}
                            getsetDialogOpenResponse={setDialogOpenResponse}
                            openCMSProps={props}></EirPrepayDeviceDetails>
                    </div>
                </div>
            )}
        </div>
    );
}
